import React from "react";

function ViewCapabilityMapModal({ isOpen, onClose, map }) {
  if (!isOpen || !map) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('en-US', {
      dateStyle: 'full',
      timeStyle: 'short'
    });
  };

  return (
    <div className="fixed inset-0 bg-slate-900 bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
        <div className="h-2" style={{ backgroundColor: map.color }}></div>
        
        <div className="px-6 py-4 border-b border-slate-200">
          <div className="flex justify-between items-start">
            <div>
              <h3 className="text-xl font-semibold text-slate-800">{map.name}</h3>
              <p className="text-sm text-slate-500" dir="rtl">{map.arabicName}</p>
            </div>
            <button onClick={onClose} className="text-slate-400 hover:text-slate-500">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <div className="overflow-y-auto p-6" style={{ maxHeight: "calc(90vh - 200px)" }}>
          <div className="grid grid-cols-3 gap-4 mb-6">
            <div className="bg-slate-50 rounded-lg p-3">
              <div className="text-xs text-slate-500 mb-1">Industry</div>
              <div className="font-medium">{map.industry}</div>
            </div>
            <div className="bg-slate-50 rounded-lg p-3">
              <div className="text-xs text-slate-500 mb-1">Version</div>
              <div className="font-medium">v{map.versionNumber}</div>
            </div>
            <div className="bg-slate-50 rounded-lg p-3">
              <div className="text-xs text-slate-500 mb-1">Level</div>
              <div className="font-medium">{map.level}</div>
            </div>
            <div className="bg-slate-50 rounded-lg p-3">
              <div className="text-xs text-slate-500 mb-1">Entity</div>
              <div className="font-medium">{map.entity}</div>
            </div>
            <div className="bg-slate-50 rounded-lg p-3">
              <div className="text-xs text-slate-500 mb-1">Status</div>
              <div className="font-medium">
                {map.revoked ? (
                  <span className="text-rose-600">Revoked</span>
                ) : map.visible ? (
                  <span className="text-green-600">Visible</span>
                ) : (
                  <span className="text-slate-600">Hidden</span>
                )}
              </div>
            </div>
            <div className="bg-slate-50 rounded-lg p-3">
              <div className="text-xs text-slate-500 mb-1">Total Items</div>
              <div className="font-medium">{map.itemsCount}</div>
            </div>
          </div>

          {/* Description */}
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-slate-800 mb-2">Description</h4>
            <p className="text-sm text-slate-600 bg-slate-50 rounded-lg p-3">
              {map.description}
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div>
              <h4 className="text-sm font-semibold text-slate-800 mb-2">Created</h4>
              <p className="text-sm text-slate-600">{formatDate(map.createdAt)}</p>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-slate-800 mb-2">Last Updated</h4>
              <p className="text-sm text-slate-600">{formatDate(map.updatedAt)}</p>
              <p className="text-xs text-slate-500">by {map.lastUpdatedBy}</p>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-slate-800 mb-3">Phases & Items</h4>
            <div className="space-y-3">
            {map.phases.map((phase, index) => (
              <div key={phase.id || index} className="border border-slate-200 rounded-lg overflow-hidden">
                <div className="bg-slate-50 px-4 py-2 flex items-center">
                  <div className="w-2 h-2 rounded-full mr-2" style={{ backgroundColor: map.color }}></div>
                  <span className="font-medium text-slate-700">{phase.title || `Phase ${index + 1}`}</span>
                  <span className="ml-auto text-xs text-slate-400">{phase.subtitle || ""}</span>
                </div>
                <div className="p-3">
                  <div className="text-sm text-slate-600 mb-2">
                    {phase.description || `This phase has ${phase.items.length} items.`}
                  </div>
                  <div className="text-xs text-slate-400">
                    Items: {phase.items.length} in this phase
                  </div>          
                  <ul className="mt-2 list-disc list-inside text-slate-500 text-xs">
                    {phase.items.map((item) => (
                      <li key={item.id}>{item.content}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
          
          </div>
        </div>
        <div className="flex justify-end px-6 py-4 border-t border-slate-200">
          <button
            onClick={onClose}
            className="btn bg-indigo-500 hover:bg-indigo-600 text-white"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewCapabilityMapModal;